var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._g(_vm._b({attrs:{"dense":"","filled":"","rounded":"","color":_vm.isDarkMode ? 'grey lighten-5' : 'primary'}},'v-textarea',{ ..._vm.$attrs, ..._vm.$props },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }